import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RedIApiService } from './redi-api.service';
import { HttpClientModule } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule,
  ],
  providers: [RedIApiService, CookieService],
  exports: []
})
export class RedIApiModule { }
